import { AssessmentFormsIndexResponse } from "../../services/api/types/forms/responses/AssessmentFormsIndexResponse";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../services/store";
import { GetSingleFormRequest } from "../../services/api/types/forms/requests/GetSingleFormRequest";
import { FormEnums } from "../../services/api/types/forms/enums/FormEnums";

interface State {
  forms: AssessmentFormsIndexResponse;
}

const initialState: State = {
  forms: [],
};

export const formsSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    storeForms: (
      state,
      action: PayloadAction<AssessmentFormsIndexResponse>,
    ) => {
      state.forms = action.payload;
    },
  },
});

export const { storeForms } = formsSlice.actions;
export const selectForms = createSelector(
  (state: RootState) => {
    return state.forms?.forms;
  },
  (forms) => forms,
);
export const selectFormsByTag = createSelector(
  [selectForms, (_: RootState, tag?: FormEnums) => tag],
  (forms, tag) => {
    if (!tag || !forms) return null;
    return forms.filter((form) => form.tag === tag);
  },
);
export const selectFormById = createSelector(
  [selectForms, (_: RootState, formId?: number) => formId],
  (forms, formId) => {
    if (!formId || !forms) return null;
    return forms.find((form) => form.id === formId);
  },
);
export default formsSlice.reducer;
